import { Box, Tag, TagLabel } from "@chakra-ui/react";
import { ApprovalStatus, TransactionStatus } from "../API";

type StatusConfigEntry = {
  label: string;
  colorScheme: string;
  dotColor: string;
};

const syncStatusConfig: Record<TransactionStatus, StatusConfigEntry> = {
  [TransactionStatus.booked]: {
    label: "Gebucht",
    colorScheme: "success",
    dotColor: "success.500",
  },
  [TransactionStatus.draft]: {
    label: "Entwurf",
    colorScheme: "gray",
    dotColor: "grayCool.500",
  },
  [TransactionStatus.extracted]: {
    label: "Extrahiert",
    colorScheme: "warning",
    dotColor: "warning.500",
  },
  [TransactionStatus.failed]: {
    label: "Fehler",
    colorScheme: "error",
    dotColor: "error.500",
  },
};

export const approvalStatusConfig: Record<
  Exclude<ApprovalStatus, ApprovalStatus.notRequired>,
  StatusConfigEntry
> = {
  [ApprovalStatus.pending]: {
    label: "Offen",
    colorScheme: "blue",
    dotColor: "blue.500",
  },
  [ApprovalStatus.approved]: {
    label: "Genehmigt",
    colorScheme: "success",
    dotColor: "success.500",
  },
  [ApprovalStatus.rejected]: {
    label: "Abgelehnt",
    colorScheme: "error",
    dotColor: "error.500",
  },
  [ApprovalStatus.changesRequested]: {
    label: "Änderung nötig",
    colorScheme: "orange",
    dotColor: "orange.500",
  },
};

type ExportStatus = "exported";

const exportStatusConfig: Record<ExportStatus, StatusConfigEntry> = {
  exported: {
    label: "Exportiert",
    colorScheme: "purple",
    dotColor: "purple.500",
  },
};

type StatusChipProps =
  | { type: "sync"; status: TransactionStatus }
  | { type: "approval"; status: ApprovalStatus }
  | { type: "export"; status: ExportStatus };

const StatusChip = (props: StatusChipProps) => {
  let config: StatusConfigEntry | undefined;

  if (props.type === "approval") {
    if (props.status === ApprovalStatus.notRequired) return null;
    config = approvalStatusConfig[props.status];
  } else if (props.type === "export") {
    config = exportStatusConfig[props.status];
  } else {
    config = syncStatusConfig[props.status];
  }

  if (!config) return null;

  return (
    <Tag
      size="sm"
      colorScheme={config.colorScheme}
      variant="subtle"
      borderRadius="full"
      data-color-scheme={config.colorScheme}
    >
      <Box
        w="6px"
        h="6px"
        borderRadius="full"
        bg={config.dotColor}
        mr="1.5"
      />
      <TagLabel>{config.label}</TagLabel>
    </Tag>
  );
};

export default StatusChip;
